import React from "react";
import { modalOverrides, sponsorModal, textModal } from "./common";
export default [
    {
        width: "5.4%",
        height: "13.1%",
        left: "38.5%",
        top: "65.3%",
        label: "SureCloud - Contact us",
        isExternal: true,
        onClick: function () {
            document.getElementById("SureCloud").click();
        }
    },
    {
        width: "5.4%",
        height: "15.1%",
        left: "56%",
        top: "63.3%",
        label: "SureCloud - SureCloud Capabilities",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2162487-635c2c1bee4d8.pdf",
        target: "_blank"
    },
    {
        width: "4.1%",
        height: "8.6%",
        left: "41%",
        top: "38.3%",
        label: "SureCloud - Play Demo",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/764627092?h=c2214785d2&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "8.1%",
        height: "5.6%",
        left: "46%",
        top: "42.3%",
        label: "SureCloud - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "SureCloud", React.createElement(React.Fragment, null, "SureCloud is a leading provider of Gartner-recognised Governance, Risk, and Compliance (GRC) solutions and Cybersecurity and Risk Advisory services, all underpinned by a single proprietary cloud-based platform. Combining software with expertise, SureCloud provides the GRC and Cyber Risk Management capabilities organisations need to achieve their desired business outcomes, while aligning with industry-recognised risk and compliance frameworks."), {
            twitter: "https://twitter.com/surecloud",
            linkedin: "https://www.linkedin.com/company/surecloud/",
            instagram: "https://www.instagram.com/surecloud/",
            facebook: "https://www.facebook.com/surecloud/",
            company: "https://www.surecloud.com/"
        })
    }
];
